
import React from 'react';
import { Ad } from '../types';
import { ExternalLink } from 'lucide-react';

interface SponsoredAdGridProps {
  ad: Ad;
}

export const SponsoredAdGrid: React.FC<SponsoredAdGridProps> = ({ ad }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(ad.link_url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div 
      className="group relative aspect-square bg-gray-100 dark:bg-zinc-900 overflow-hidden cursor-pointer active:opacity-95 transition-all shadow-sm"
      onClick={handleClick}
    >
      <img 
        src={ad.image_url} 
        alt={ad.title}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        loading="lazy"
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-60 group-hover:opacity-80 transition-opacity" />

      {/* Sponsored Badge */}
      <div className="absolute top-2 left-2 flex flex-col gap-1 items-start z-10">
        <span className="px-2 py-1 bg-blue-600/90 backdrop-blur-md rounded-md text-[8px] md:text-[9px] font-black uppercase tracking-wider text-white shadow-lg flex items-center gap-1">
          Sponsored
        </span>
      </div>

      {/* External Link Indicator */}
      <div className="absolute top-2 right-2 z-10">
        <div className="bg-white/20 backdrop-blur-sm p-1.5 rounded-full text-white border border-white/20">
          <ExternalLink className="w-3 h-3" />
        </div>
      </div>

      {/* Bottom Info (Optional/Minimal) */}
      <div className="absolute bottom-2 left-2 right-2 z-10">
        <div className="flex flex-col gap-0.5 min-w-0">
          <div className="text-[10px] font-black text-white leading-none tracking-tight uppercase truncate">
            {ad.title}
          </div>
        </div>
      </div>

      <div className="absolute inset-0 bg-white/5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
    </div>
  );
};
